import { css } from 'styled-components';

import check from '../images/check.svg';
import ArrowRight from '../images/small-arrow-right.svg';

import Spacings from './Spacings';

export default {
  unorderedList: css`
    ul {
      list-style-image: url(${check});
      margin-bottom: 0;
      margin-top: 0;
      padding-left: 21px;
    }

    li {
      margin-bottom: 12px;
      padding-left: ${Spacings.XS};

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `,
  arrowUnorderedList: css`
    ul {
      list-style-image: none;
      margin-bottom: 0;
      margin-top: 0;
      padding-left: 21px;

      &:not(li:has(a)) {
        list-style-image: url(${check});
      }
    }

    li {
      margin-bottom: 12px;
      padding-left: ${Spacings.XXS};
      position: relative;

      &:has(a) {
        list-style: none;
      }

      a {
        &:before {
          content: '';
          position: absolute;
          top: 6px;
          left: -21px;
          height: 1rem;
          width: 1rem;
          background: url(${ArrowRight}) no-repeat;
          transition: 0.1s ease-in-out;
        }
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `,
};
